import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./locales/fr.json";
import en from "./locales/en.json";

void i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    // Conservé pour les tests de parité i18n ; l’UI applicative démarre en français.
    en: { translation: en },
  },
  lng: "fr",
  fallbackLng: "fr",
  supportedLngs: ["fr", "en"],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
